import React from "react";
import { useTheme } from "./ThemeContext";

const ThemeToggle = () => {
  const { isDarkMode, toggleTheme } = useTheme();

  return (
    <button
      onClick={toggleTheme}
      aria-label={isDarkMode ? "Switch to light mode" : "Switch to dark mode"}
      title={isDarkMode ? "Switch to light mode" : "Switch to dark mode"}
      style={{
        position: "fixed",
        bottom: "20px",
        left: "20px",
        width: "44px ",
        height: "44px ",
        borderRadius: "50%",
        border: "2px solid var(--careforge-border-color)",
        backgroundColor: "var(--careforge-background-secondary)",
        color: "var(--careforge-text-primary)",
        cursor: "pointer",
        fontSize: "20px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        boxShadow: "0 2px 12px rgba(0, 0, 0, 0.15)",
        zIndex: 9999,
        transition: "all 0.3s ease",
        padding: 0,
        lineHeight: 1,
      }}
    >
      {isDarkMode ? "☀️" : "🌙"} {/* Sun and Moon icons */}
    </button>
  );
};

export default ThemeToggle;
